import moment from "moment-timezone";

const dateRangeToDate = (dateRange) => {
  const today = moment();
  switch (dateRange) {
    case "Y": {
      // last day
      return {
        startDate: today.clone().subtract(1, "days").format("DD.MM.YYYY"),
        endDate: today.format("DD.MM.YYYY"),
      };
    }
    case "7D": {
      // last 7 days
      return {
        startDate: today.clone().subtract(7, "days").format("DD.MM.YYYY"),
        endDate: today.format("DD.MM.YYYY"),
      };
    }
    case "30D": {
      // last 30 days
      return {
        startDate: today.clone().subtract(30, "days").format("DD.MM.YYYY"),
        endDate: today.format("DD.MM.YYYY"),
      };
    }
    case "90D": {
      // last 90 days
      return {
        startDate: today.clone().subtract(90, "days").format("DD.MM.YYYY"),
        endDate: today.format("DD.MM.YYYY"),
      };
    }
    case "MTD": {
      // this month
      return {
        startDate: today.clone().startOf("month").format("DD.MM.YYYY"),
        endDate: today.format("DD.MM.YYYY"),
      };
    }
    case "LM": {
      // last month
      return {
        startDate: today
          .clone()
          .subtract(1, "month")
          .startOf("month")
          .format("DD.MM.YYYY"),
        endDate: today
          .clone()
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY"),
      };
    }
    case "L3M": {
      // last 3 months
      return {
        startDate: today.clone().subtract(3, "months").format("DD.MM.YYYY"),
        endDate: today.format("DD.MM.YYYY"),
      };
    }
    case "L6M": {
      // last 6 months
      return {
        startDate: today.clone().subtract(6, "months").format("DD.MM.YYYY"),
        endDate: today.format("DD.MM.YYYY"),
      };
    }
  }
};

export { dateRangeToDate };
